import type { Translatable } from "app/pages/sales-intelligence/types";

export const DESCRIPTION_TRANSLATABLE: Readonly<Translatable> = {
    key: `si.signals.edit-signal.description`,
};
